import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logoImg from "../../../assets/images/branding/logo-torneiofacil.png";
import useAuthenticate from "../../../hooks/useAuthenticate";
import {
  CloseMenuButton,
  Container,
  Navbar,
  NavbarLogo,
  NavbarMenu,
  NavbarMenuIcon,
  NavbarMenuItem,
  NavbarMenuLink,
} from "./styles";
import { CircularProgress } from "@mui/material";

const NavBar: React.FC = () => {
  const { authenticated, destroyToken, loading } = useAuthenticate();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const isActive = (path: string) => location.pathname === path;

  const logout = () => {
    destroyToken();
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  const renderAuthLinks = () => {
    if (authenticated === undefined) return <CircularProgress sx={{ color: 'white' }} size={24} />;

    if (authenticated) {
      return (
        <>
          <NavbarMenuItem>
            <a
              href="https://wa.me/5592981291027?text=Ol%C3%A1!%20Gostaria%20de%20criar%20meu%20torneio%20no%20Torneio%20F%C3%A1cil."
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              <NavbarMenuLink>
                Crie seu Torneio
              </NavbarMenuLink>
            </a>
          </NavbarMenuItem>
          <NavbarMenuItem>
            <Link to="/" onClick={closeMenu}>
              <NavbarMenuLink $active={isActive("/")}>
                Torneios
              </NavbarMenuLink>
            </Link>
          </NavbarMenuItem>
          <NavbarMenuItem>
            <Link to="/profile" onClick={closeMenu}>
              <NavbarMenuLink $active={isActive("/profile")}>
                Meu Perfil
              </NavbarMenuLink>
            </Link>
          </NavbarMenuItem>
          <NavbarMenuItem>
            <NavbarMenuLink
              $variant="logout"
              onClick={() => { closeMenu(); logout(); }}
            >
              Logout
            </NavbarMenuLink>
          </NavbarMenuItem>
        </>
      );
    }

    return (
      <>
        <NavbarMenuItem>
          <a
            href="https://wa.me/5592981291027?text=Ol%C3%A1!%20Gostaria%20de%20criar%20meu%20torneio%20no%20Torneio%20F%C3%A1cil."
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
          >
            <NavbarMenuLink>
              Crie seu Torneio
            </NavbarMenuLink>
          </a>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link to="/" onClick={closeMenu}>
            <NavbarMenuLink $active={isActive("/")}>
              Torneios
            </NavbarMenuLink>
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link to="/login" onClick={closeMenu}>
            <NavbarMenuLink $active={isActive("/login")}>
              Login
            </NavbarMenuLink>
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link to="/register" onClick={closeMenu}>
            <NavbarMenuLink $active={isActive("/register")}>
              Registrar
            </NavbarMenuLink>
          </Link>
        </NavbarMenuItem>
      </>
    );
  }

  return (
    <Navbar>
      <Container>
        <Link to={"/"}>
          <NavbarLogo src={logoImg} />
        </Link>
        <NavbarMenu isOpen={isOpen}>
          <CloseMenuButton onClick={closeMenu}>
            <FaTimes />
          </CloseMenuButton>
          {renderAuthLinks()}
        </NavbarMenu>
        <NavbarMenuIcon onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </NavbarMenuIcon>
      </Container>
    </Navbar>
  );
};

export default NavBar;
